import formatCurrency from '../util/formatCurrency'


export default function getRepairs(order) {
  return [
    {
      id:               1,
      description:      'A Repair',
      comments:         '',
      encodedLaborTime: '0015',
      number:           '012345',
      printed:          true,
      prices:           getPrices(5.20, order),
    },
    {
      id:               2,
      description:      'Another Repair',
      comments:         'with some notes',
      encodedLaborTime: '0130',
      number:           '099441',
      printed:          true,
      prices:           getPrices(37.67, order),
    },
    {
      id:               3,
      description:      'One More Repair',
      comments:         '',
      encodedLaborTime: '0045',
      number:           '060606',
      printed:          true,
      prices:           getPrices(120.99, order),
    },
  ]
}


function getPrices(val, order) {
  var prices = []
  if (order.pricingFormat === "Agreement Savings") {
    prices = [
      val,        // "Repair Fee"
      val * 1.5,  // "After Hours"
      val * 0.8,  // "Service Agreement"
    ]
    prices.push(prices[0] - prices[2]) // "Agreement Savings"
  }
  else if (order.pricingFormat === "Agreement Reg-OT") {
    prices = [
      val,        // "Repair Fee"
      val * 0.8,  // "Service Agreement"
      val * 1.5,  // "After Hours"
    ]
    prices.push(prices[2] * 0.8) // "After Hours Agreement"
  }
  else if (order.pricingFormat === "Primary Additional") {
    prices = [
      val,        // "Regular Primary"
      val * 0.6,  // "Regular Additional"
      val * 1.5,  // "Overtime Primary"
    ]
    prices.push(prices[2] * 0.6) // "Overtime Additional
  }
  return prices.map(v => ({total: formatCurrency(v, order.roundedPrices)}))
}
